module.exports = __webpack_public_path__ + "static/media/linkedin.12e9c34e.svg";